import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { WebUserProfileDto } from './WebUserProfileDto'
import { UserTelegramDto } from './UserTelegramDto'
/**
* Class WebUserDto
*  Пользователь витрины в рамках customer pool
*/
export class WebUserDto extends ActiveModel {

  /**
  * id
  * ИД записи в БД<br>  */
  @ActiveField(0)
  id: number = 0


/**
  * created
  * Отметка времени создания<br>
  */
  @ActiveField('')
  created: string = ''


/**
  * updated
  * Отметка времени обновления<br>
  */
  @ActiveField('')
  updated: string = ''


/**
  * deleted
  * Отметка времени удаления<br>
  */
  @ActiveField(null)
  deleted: null | string = null


/**
  * email
  * Email-адрес пользователя<br>
  */
  @ActiveField(null)
  email: null | string = null


/**
  * phone
  * Номер телефона пользователя<br>
  */
  @ActiveField(null)
  phone: null | string = null


  /**
  * profile
  * Данные профиля пользователя<br>  */
  @ActiveField({
    factory: [WebUserProfileDto, () => WebUserProfileDto.create()]
  })
  profile: WebUserProfileDto = WebUserProfileDto.create()


  /**
  * telegram
  * Данные привязки телеграм для текущей витрины<br>  */
  @ActiveField({
    factory: [UserTelegramDto, () => UserTelegramDto.create()]
  })
  telegram: UserTelegramDto = UserTelegramDto.create()
}
